import React from 'react';
import { PieceType, Color } from '../../engine/types';
import { pieceSetManager } from '../utils/pieceSets';
import './Piece.css';

interface PieceProps {
  type: PieceType;
  color: Color;
  draggable?: boolean;
  dragging?: boolean;
  pieceSet?: string; // Optional prop to trigger re-render on piece set change
  onDragStart?: (e: React.DragEvent<HTMLDivElement>) => void;
  onDragEnd?: (e: React.DragEvent<HTMLDivElement>) => void;
}

/**
 * Renders a chess piece using the current piece set
 * Note: pieceSet prop is passed but not destructured - it's used to trigger re-renders
 */
const Piece: React.FC<PieceProps> = ({ type, color, draggable = false, dragging = false, onDragStart, onDragEnd }) => {
  const symbol = pieceSetManager.getPieceSymbol(type, color);
  const colorClass = color === Color.White ? 'piece-white' : 'piece-black';
  const draggableClass = draggable ? 'piece-draggable' : '';
  const draggingClass = dragging ? 'piece-dragging' : '';

  return (
    <div 
      className={`piece ${colorClass} ${draggableClass} ${draggingClass}`}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
    >
      {symbol}
    </div>
  );
};

export default Piece;
